var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TextField',{attrs:{"model":_vm.readableModel,"name":_vm.field.id,"element":_vm.readonlyField(_vm.field)},on:{"focus":function($event){return $event.target.select()}}})}
var staticRenderFns = []

export { render, staticRenderFns }